import React, { useEffect, useRef, useState } from 'react';

import { Layout, Text } from 'ds';
import { formatUsd } from 'helpers';

interface PriceTagProps {
  amountCents: number;
  unitLabel?: string;
}

const PriceTag: React.FC<PriceTagProps> = ({ amountCents, unitLabel }) => {
  const formattedPrice = formatUsd(amountCents ? amountCents / 100 : 0, true);
  const [dollars, cents] = formattedPrice.replace('$', '').split('.');
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight);
    }
  }, [containerRef]);

  return (
    <Layout flex direction="row" height="100%" align="flex-start" __ref={containerRef}>
      <Text size="headline-sm">${dollars}</Text>
      <Layout height={containerHeight} minHeight={containerHeight} flex align="flex-start">
        <Text size="body-sm">{cents}</Text>
      </Layout>
      {unitLabel && (
        <Layout height={containerHeight} minHeight={containerHeight} flex align="flex-end" marginLeft={2}>
          <Text size="body-sm">{unitLabel}</Text>
        </Layout>
      )}
    </Layout>
  );
};

export default PriceTag;
